import { LoadingManager, TextureLoader, Texture } from "three";
import { GLTFLoader, GLTF } from "three/examples/jsm/loaders/GLTFLoader";
import { ResourcesOptions } from "./resources";

export type AllRes = {
  groundModel: Promise<GLTF>;
  globeTexture: Texture;
};

const loadingMsgs = [
  "火箭燃料加注完毕，正在整备...",
  "火箭整备完毕，等待发射...",
  "点火发射！遥测跟踪...",
  "遥测跟踪正常，准备进入轨道...",
  "进入地火转移轨道...",
  "轨道进入成功...",
  "火星任务圆满成功！",
]

const logProcess = (content: string) => {
  const el = document.getElementById('loading-process')
  const msg = document.createElement('p')
  msg.innerHTML = content
  el?.appendChild(msg)
}

export const loadAllResource = (res: ResourcesOptions): AllRes => {
  logProcess(`10%: ${loadingMsgs.shift()}`)
  var manager = new LoadingManager();
  manager.onLoad = function () {
    console.log("Loading complete!");
    logProcess(`100%: ${loadingMsgs.shift()}`)
    setTimeout(() => {
      const el = document.getElementById('loading-process')
      el?.parentElement?.removeChild(el)
    }, 3000);
  };
  manager.onProgress = function (url, itemsLoaded, itemsTotal) {
    logProcess(`${Math.round(itemsLoaded * 100 / itemsTotal).toString()}%: ${loadingMsgs.shift()}`)
    console.log(url);
  };
  manager.onError = function (url) {
    console.log("There was an error loading " + url);
    logProcess(`0%: 火星任务失败。 ${url} 资源加载失败！`)
  };

  const fbxPromise = new Promise<GLTF>((r, j) => {
    new GLTFLoader(manager).load(res.groundModel, r);
  });

  return {
    groundModel: fbxPromise,
    globeTexture: new TextureLoader(manager).load(res.globeTexture),
  };
};